import cn from '@/lib/clsxm';

import Button from '@/components/@base/button';
import { Props } from '@/components/app/product/components/table-contents/table-contents-list/type';
import IconTextCombo from '@/components/shared/components/icon-text-combo';

import { pageLevelLocalization } from '@/constant/localization';

import Grid3 from '~/images/icons/grid3';
const { product: productLocalization } = pageLevelLocalization;

export default function TableContentsList({
  items,
  activeItem,
  onSelectTab,
  isExtraLarge,
  closeDrawer,
  itemClassName,
  textClassName,
  wrapperClassName,
}: Props) {
  return (
    <>
      <IconTextCombo
        Icon={<Grid3 width={isExtraLarge ? '20' : '18'} color='#565656' />}
        title={productLocalization.productList}
        wrapperClassName={wrapperClassName}
        textClassName={cn(
          'text-[14px]! 2xl:text-[15px]! font-bold  tracking-tighter -mr-2 text-[#5B5C60]!',
          isExtraLarge && 'font-[600]! -mt-1!',
        )}
      />
      {items.map((item, index) => (
        <Button
          key={index}
          onClick={() => {
            onSelectTab(item.tab, item.sectionId, item.key);
            closeDrawer?.();
          }}
          className={cn(
            itemClassName,
            activeItem === item.key
              ? 'bg-[#FFF7EA]! text-[#FFAF1C]!'
              : 'bg-white text-[#5B5C60]! hover:bg-[#FFF7EA]',
          )}
        >
          {activeItem === item.key && (
            <div
              className={cn(
                isExtraLarge ? 'top-3' : 'top-1.5',
                'absolute right-0 z-20 h-[23px] w-0.5 bg-[#FFAF1C]',
              )}
            />
          )}
          <IconTextCombo
            Icon={item.icon}
            title={item.title}
            wrapperClassName={cn(wrapperClassName)}
            textClassName={cn(
              'font-bold! tracking-tighter!',
              textClassName,
              activeItem === item.key ? 'text-[#424242]!' : 'text-[#5B5C60]!',
            )}
          />
        </Button>
      ))}
    </>
  );
}
